import { Component, EventEmitter, Input, Output } from '@angular/core';
import { LogService } from 'services/log/log.service';
import { StepService } from 'services/professional/step/step.service';
import { MessageQueryService } from '@certemy/ui-components';
import { PAGES } from '../../../log-details/log-details.component';
import { ComputedFrom } from '@certemy/common';
import { isPendingVerificationStatus } from 'utils/step.helpers';
import { VERIFICATION_TYPE } from 'constants/constants';

@Component({
  selector: 'cm-entries',
  templateUrl: './entries.component.html',
  styleUrls: ['./entries.component.scss', '../../../step-details.shared.scss'],
})
export class EntriesComponent {
  @Input() step;
  @Input() stepEditableStatus: boolean;
  @Output() close: EventEmitter<any> = new EventEmitter();
  @Output() dismissModal: EventEmitter<any> = new EventEmitter();
  @Output() openEntryForm: EventEmitter<any> = new EventEmitter();
  @Output() goToPage = new EventEmitter();
  readonly PAGES = PAGES;
  readonly VERIFICATION_TYPE = VERIFICATION_TYPE;

  @ComputedFrom('step', 'stepEditableStatus')
  get canSubmit(): boolean {
    return this.step.content.allowMultipleEntries
      ? this.stepEditableStatus
      : this.step.content.number_completed < this.step.content.number_required && this.stepEditableStatus;
  }

  @ComputedFrom('step')
  get isPendingVerificationStatus() {
    return isPendingVerificationStatus(this.step.status_id);
  }

  @ComputedFrom('step', 'stepEditableStatus')
  get showNotification(): boolean {
    return this.step.content.allowMultipleEntries && this.step.entries.some((entry) => entry.isDraft);
  }

  constructor(
    private logService: LogService,
    private messageService: MessageQueryService,
    private stepService: StepService,
  ) {}

  closeModal() {
    this.close.emit();
  }

  previewEntry(event) {
    this.logService
      .readEntry(this.step.step_instance_id, event.entry.id)
      .subscribe((response) => this.openEntry(response));
  }

  openEntry(entry) {
    this.openEntryForm.emit({
      page: PAGES.CRUD_ENTRY,
      entry,
    });
  }

  confirmStep() {
    this.stepService.submitLogStep(this.step.step_instance_id).subscribe(
      () => {
        this.closeModal();
        const messageText = [
          VERIFICATION_TYPE.VERIFICATION_REQUIRED,
          VERIFICATION_TYPE.DOUBLE_VERIFICATION_REQUIRED,
        ].includes(this.step.verificationType)
          ? 'Step has been submitted for review'
          : 'Step has been completed';
        this.messageService.addMessage(messageText);
      },
      () => this.messageService.addErrorMessage(`${this.step.name} has failed to get submitted. Please, try again`),
    );
  }
}
